module.exports = __webpack_public_path__ + "img/larochelle.485e4185.jpg";